/**
 * 康巴圣德经营数据（/sell）字段模型
 * 后台按区块分组展示可编辑字段（中文 label + 类型 + 默认值），前端用 $C(scope, key, default) 读取。
 * 说明：本页数据（产值/销售额/采购/快递/收发/地域）均由后端接口 /api/web/file/data/query 实时拉取，
 *       非页面内置常量，因此数据数组不在此处外置（保留接口实时数据），仅外置可见中文文案。
 */
export default {
  title: '康巴圣德经营数据',
  groups: [
    {
      title: '经营数据卡片',
      fields: [
        { key: 'outTitle', label: '产值统计·卡片标题', type: 'text', default: '产值统计' },
        { key: 'outTabMonth', label: '产值统计·月产值按钮', type: 'text', default: '月产值' },
        { key: 'outTabYear', label: '产值统计·年产值按钮', type: 'text', default: '年产值' },
        { key: 'sellTitle', label: '销售额统计·卡片标题', type: 'text', default: '销售额统计' },
        { key: 'sellTabMonth', label: '销售额统计·月销售额按钮', type: 'text', default: '月销售额' },
        { key: 'sellTabYear', label: '销售额统计·年销售额按钮', type: 'text', default: '年销售额' },
        { key: 'buyTitle', label: '原料采购统计·卡片标题', type: 'text', default: '原料采购统计' },
        { key: 'buyTabMonth', label: '原料采购统计·月原料采购按钮', type: 'text', default: '月原料采购' },
        { key: 'buyTabYear', label: '原料采购统计·年原料采购按钮', type: 'text', default: '年原料采购' },
      ],
    },
    {
      title: '快递统计（中间）',
      fields: [
        { key: 'expressLabelCount', label: '快递统计·件数', type: 'text', default: '件数' },
        { key: 'expressLabelAccept', label: '快递统计·已签收', type: 'text', default: '已签收' },
        { key: 'expressLabelPercent', label: '快递统计·签收比例', type: 'text', default: '签收比例' },
      ],
    },
    {
      title: '收发货明细表',
      fields: [
        { key: 'thFhd', label: '表头·发货地', type: 'text', default: '发货地' },
        { key: 'thShd', label: '表头·收件地', type: 'text', default: '收件地' },
        { key: 'thJs', label: '表头·件数', type: 'text', default: '件数' },
        { key: 'thYqs', label: '表头·已签收', type: 'text', default: '已签收' },
        { key: 'thKdqsbl', label: '表头·签收比例(%)', type: 'text', default: '签收比例(%)' },
      ],
    },
    {
      title: '销售地域统计',
      fields: [
        { key: 'areaTitle', label: '卡片标题', type: 'text', default: '销售地域统计' },
      ],
    },
  ],
}
